import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M31.625 31.625H14.0861C13.4872 31.625 13.1877 31.625 12.9589 31.5084C12.7577 31.4059 12.5941 31.2423 12.4916 31.0411C12.375 30.8123 12.375 30.5128 12.375 29.9139V12.375M30.5556 17.7222L26.3645 22.1953C26.2057 22.3649 26.1263 22.4496 26.0305 22.4934C25.9459 22.5321 25.8527 22.5481 25.7601 22.5397C25.6552 22.5303 25.5521 22.4767 25.3459 22.3697L21.8624 20.5609C21.6562 20.4538 21.5531 20.4003 21.4482 20.3908C21.3556 20.3825 21.2624 20.3984 21.1778 20.4371C21.082 20.4809 21.0026 20.5657 20.8438 20.7352L16.6528 25.2083",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.66602 5.66675C3.66602 4.56218 4.56145 3.66675 5.66602 3.66675H38.3327C39.4372 3.66675 40.3327 4.56218 40.3327 5.66675V38.3334C40.3327 39.438 39.4372 40.3334 38.3327 40.3334H5.66602C4.56145 40.3334 3.66602 39.438 3.66602 38.3334V5.66675Z",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }